import React from 'react';
import isEqual from 'lodash.isequal';
import '../scss/emailchips.scss';
import WarningFilled16 from '@carbon/icons-react/lib/warning--filled/16';
import PropTypes from 'prop-types';

export default class EmailChips extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      error: null,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !isEqual(nextProps, this.props) || !isEqual(nextState, this.state);
  }

  handleChange = (evt) => {
    this.setState({
      value: evt.target.value,
      error: null,
    });
  };

  clearInput = () => {
    this.setState({ value: '' });
  };

  setError = (error) => {
    this.setState({ error });
  };

  convertItems = (value, type, outType) => {
    if (!value) return outType === 'text' ? '' : [];

    if (type === outType) return value;

    if (outType === 'text') {
      return value.join();
    }
    // array
    return value.split(',');
  };

  render() {
    const items = this.convertItems(this.props.value, this.props.type, 'array');

    function isInList(email) {
      return items.includes(email);
    }

    function isEmail(email) {
      return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
    }

    const isMasked = () => {
      return this.props.masked; //RITM0946001 - Anonimizzazione Modulo Incident;
    }

    const isValid = (email) => {
      let error = null;

      if (isInList(email)) {
        error = `${email} has already been added.`;
      }

      if (!isEmail(email)) {
        error = `${email} is not a valid email address.`;
      }

      //RITM0946001 - Anonimizzazione Modulo Incident
      if(isMasked()){
        error = `${email} cannot be added for already masked personal information.`;
      }
      //End

      if (error) {
        this.setError(error);
        return false;
      }

      return true;
    };

    //RITM0946001 - Anonimizzazione Modulo Incident
    const canDelete = (email) => {
      let error = null;

      if(isMasked()){
        error = `${email} cannot be deleted for already masked personal information.`;
      }

      if (error) {
        this.setError(error);
        return false;
      }

      return true;
    }
    //End

    const handleSave = (array) => {
      this.props.onChange(this.convertItems(array, 'array', this.props.type));
    };

    const handleKeyDown = (evt) => {
      if (['Enter', 'Tab', ','].includes(evt.key)) {
        evt.preventDefault();

        const value = this.state.value.trim();

        if (value && isValid(value)) { 
          const array = [...items, this.state.value];
          handleSave(array);
          this.clearInput();
        }
      }
    };

    const handleDelete = (item) => {
      if (canDelete(item)) {  //RITM0946001 - Anonimizzazione Modulo Incidents
      const array = items.filter((i) => i !== item);
      handleSave(array);
      }
    };

    const handlePaste = (evt) => {
      evt.preventDefault();
      const paste = evt.clipboardData.getData('text');
      const emails = paste.match(/[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/g);

      if (emails) {
        const toBeAdded = emails.filter((email) => isEmail(email) && !isInList(email) && !isMasked()); //RITM0946001 - Anonimizzazione Modulo Incident

        const array = [...items, ...toBeAdded];
        handleSave(array);
        this.clearInput();
      }
    };

    return (
      <div className={`email-chips${this.props.disabled ? ' tag-item-disabled' : ''}`}>
        <div className="bx--text-input__field-wrapper">
          {this.state.error || this.props.invalid ? (
            <WarningFilled16 className="bx--text-input__invalid-icon" />
          ) : null}
          <input
            className={`bx--text-input ${
              this.state.error || this.props.invalid ? ' bx--text-input--invalid' : ''
            }`}
            value={this.state.value}
            placeholder={
              this.props.placeholder ||
              'Type or paste email addresses comma, semicolon or space separated and press `Enter`...'
            }
            onKeyDown={handleKeyDown}
            onChange={this.handleChange}
            onPaste={handlePaste}
            disabled={this.props.disabled}
            title={this.props.title ?? null}
          />
        </div>
        {this.state.error && <p className="srv-validation-message">{this.state.error}</p>}

        {items.map((item) => (
          <div className="tag-item" key={item}>
            {item}
            {this.props.disabled ? null : (
              <button type="button" className="button" onClick={() => handleDelete(item)}>
                &times;
              </button>
            )}
          </div>
        ))}
      </div>
    );
  }
}
EmailChips.propTypes = {
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  masked: PropTypes.bool, //RITM0946001 - Anonimizzazione Modulo Incident
};
EmailChips.defaultProps = {
  invalid: false,
  disabled: true,
  placeholder: '',
  type: 'text',
  value: '',
  masked: false, //RITM0946001 - Anonimizzazione Modulo Incident
};
